import { Component } from '@angular/core'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { AdminSaleCourseCancelMode } from '../sale'

@Component({
  selector: 'sale-course-cancel-modal',
  templateUrl: './sale-course-cancel-modal.component.html'
})
export class SaleCourseCancelModalComponent {
  public readonly courseCancelMode = AdminSaleCourseCancelMode
  public selectedMode: AdminSaleCourseCancelMode | null =
    AdminSaleCourseCancelMode.FUTURE_ONLY

  constructor(private bsModalRef: BsModalRef) {}

  public cancel(): void {
    this.selectedMode = null
    this.bsModalRef.hide()
  }

  public confirm(): void {
    this.bsModalRef.hide()
  }
}
